import { Component, output } from '@angular/core';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { ButtonStyles } from '../../../button/button.component';
import { MigrationsCardAbstractDirective } from '../migrations-card-abstract.directive';

@Component({
  selector: 'ziro-migrations-text-card',
  templateUrl: 'migrations-text-card.component.html',
  styleUrls: ['migrations-text-card.component.scss'],
  standalone: false,
})
export class MigrationsTextCardComponent extends MigrationsCardAbstractDirective {
  readonly dataClick = output<string>();
  readonly errorButtonClick = output<void>();

  ZiroIcons = ZiroIcons;
  ButtonStyles = ButtonStyles;

  constructor() {
    super();
  }

  onCardClick($event: any): void {
    if (this.isError() || this.isDisabled()) {
      return;
    }

    const blockedClasses = ['icon-refresh'];
    const cssClasses = ($event.target as HTMLElement).classList;
    const clickedBlockClasses = blockedClasses.some((blockedClass) => cssClasses.contains(blockedClass));
    if (!clickedBlockClasses) {
      this.dataClick.emit('');
    }
  }

  onErrorButtonClick(): void {
    this.errorButtonClick.emit();
  }
}
